import { useState } from 'react';
import dynamic from 'next/dynamic';

import type { ButtonSize, ButtonVariant } from '@/atoms/button/types';

const ModalForm = dynamic(() => import('@/molecules/modal-form'), {
  ssr: true,
});
const ContactForm = dynamic(() => import('@/molecules/contact-form'), {
  ssr: true,
});

/** Componente Strapi `revisadas.boton` tal como llega por GraphQL. */
export type TypeBotonCms = {
  Texto?: string | null;
  Link?: string | null;
  Size?: ButtonSize | null;
  Variante?: ButtonVariant | null;
  Tipo?: 'Link' | 'Contacto' | null;
  Destinatario?: { documentId: string; Nombre?: string | null } | null;
};

export const isBotonContacto = (boton?: TypeBotonCms | null) =>
  boton?.Tipo === 'Contacto';

/**
 * Un botón CMS con `Tipo = Contacto` abre el formulario de contacto en modal
 * y manda el email al `Destinatario` del propio botón. El bloque renderiza
 * `modal` una vez y llama a `abrirContacto(boton)` desde el onClick.
 */
export const useBotonContacto = () => {
  const [boton, setBoton] = useState<TypeBotonCms | null>(null);

  const modal = (
    <ModalForm
      isOpen={!!boton}
      closeModal={() => setBoton(null)}
      title="Contacto"
    >
      <ContactForm destinatario={boton?.Destinatario?.documentId} />
    </ModalForm>
  );

  return { modal, abrirContacto: setBoton };
};
